// src/components/TeamsManager.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useAuth } from "../../Context/AuthContext";
import TeamForm from "../TeamForm/TeamForm"; // ודא שהנתיב נכון
import "./TeamsManager.css";
import TeamImageModal from "../TeamImageModal/TeamImageModal";

// import { FaSortAlphaDown,FaSortAlphaDownAlt  } from "react-icons/fa";

const API = process.env.REACT_APP_API;

const TeamsManager = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const [leagues, setLeagues] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [structureOverlayOpen, setStructureOverlayOpen] = useState(false);
  const [structureImage, setStructureImage] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);

  const [overlayOpen, setOverlayOpen] = useState(false);
  const [editingTeam, setEditingTeam] = useState(null);

  const [sortOrders, setSortOrders] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [leaguesRes, teamsRes] = await Promise.all([
        axios.get(`${API}/api/leagues`),
        axios.get(`${API}/api/teams`),
      ]);
      setLeagues(leaguesRes.data);
      setTeams(teamsRes.data);
    } catch (err) {
        console.error(err);
        toast.error("שגיאה בטעינת הנתונים");
    }
  };

  // מחלק את הקבוצות לפי ליגה לפי סדר
  const teamsByLeague = (leagueId) => {
    const order = sortOrders[leagueId] || "asc";        // א'-ב' כברירת מחדל
    return teams
    .filter((t) => String(t.leagueId._id || t.leagueId) === String(leagueId))
    .sort((a, b) => {
      const nameA = a.name.trim();
      const nameB = b.name.trim();

      const isEnglishA = /^[A-Za-z]/.test(nameA);
      const isEnglishB = /^[A-Za-z]/.test(nameB);

      // שלב ראשון: קודם שמות באנגלית, אחר כך בעברית
      if (isEnglishA && !isEnglishB) return -1;
      if (!isEnglishA && isEnglishB) return 1;

      // שלב שני: מיון פנימי לפי שם בסדר יורד (Z→A או ת→א)
      const cmp = nameA.localeCompare(nameB, "he", { sensitivity: "base" });
      return order === "asc" ? cmp : -cmp;
    });
  }

  // const changeLeagueSort = (leagueId, order) => {
  //   setSortOrders(prev => ({ ...prev, [leagueId]: order }));
  // };

  // הוספת קבוצה חדשה
  const openAddOverlay = () => {
    setEditingTeam(null);
    setOverlayOpen(true);
  };

  // עריכת קבוצה קיימת
  const openEditOverlay = (team) => {
    setEditingTeam(team);
    setOverlayOpen(true);
  };

  // לאחר שמירה בטופס
  const handleFormSaved = async () => {
    setOverlayOpen(false);
    await fetchData();
  };

  return (
    <div className="teams-manager-container">
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/leagues")}/>
      </div>
      
      {/* Title */}
      <div className="main-title">
        <h2>מבנה הליגות</h2>
      </div>

    <div className="league-box">
      {leagues.map(lg => (
        <button
          key={lg._id}
          className="league-structure-btn"
          onClick={() => {
            if (lg.structureFile) {
              setStructureImage(lg.structureFile);
              setStructureOverlayOpen(true);
            } else {
              alert("אין קובץ זמין");
            }
          }}
        >
          {lg.name}
        </button>
      ))}
    </div>

    {/* כותרת הקבוצות + כפתור הוספה קרוב לכותרת */}
    {/* Teams Section */}
    <div className="teams-header">
      <h2>הקבוצות</h2>
      {user?.isAdmin && (
        <button className="add-team-btn" onClick={openAddOverlay}>
          ➕ הוספת קבוצה חדשה
        </button>
      )}
    </div>
   
   {/* Teams by League */}
   {/* רשימת הקבוצות לפי ליגות */}
    <div className="leaguesName-grid">
      {leagues.map((league) => (
        <div key={league._id} className="leagueName-column">
          <h3>
            {league.name}
            {/* <span className="sort">
              {sortOrders[league._id]==="desc" ? <FaSortAlphaDownAlt onClick={() => changeLeagueSort(league._id, "asc")} title="מיון עולה"/> : <FaSortAlphaDown onClick={() => changeLeagueSort(league._id, "desc")} title="מיון יורד" /> }
            </span> */}
          </h3>
          
          <div className="teams-list">
            {teamsByLeague(league._id).map((team) => (
              <div key={team._id} className="team-item">
                <span
                  className="team-column-name"
                  onClick={() => { setSelectedTeam(team); setModalOpen(true); }}
                >
                  {team.name}
                </span>
                {user?.isAdmin && ( 
                <div className="team-actions">
                  <button
                    onClick={() => openEditOverlay(team)}
                    title="עריכה">
                      ✎
                  </button>
                </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
      
    {/* Team image modal */}
    <TeamImageModal
      isOpen={modalOpen}
      onClose={() => setModalOpen(false)}
      teamName={selectedTeam?.name}
      imageUrl={selectedTeam?.image?.trim() || null}
    />

    {structureOverlayOpen && (
      <div className="overlay-bg" onClick={() => setStructureOverlayOpen(false)}>
        <div className="overlay-content image-overlay" onClick={(e) => e.stopPropagation()}>
          <button className="X-btn" onClick={() => setStructureOverlayOpen(false)}>
            ✖
          </button>
          <img
            src={structureImage}
            alt="League Structure"
            className="structure-image"
          />
        </div>
      </div>
    )}

    {/* טופס הוספה/עריכה (overlay פנימי) */}
    {overlayOpen && (
      <div className="overlay-bg">
        <div className="overlay-content">
          <div className="overlay-header">
            <h3>{editingTeam ? "עריכת קבוצה" : "הוספת קבוצה"}</h3>
            <button
              className="close-btn"
              onClick={() => {
                setOverlayOpen(false);
                setEditingTeam(null);
              }}
            >
              ✖
            </button>
          </div>
          <TeamForm
            editingTeam={editingTeam}
            onSaved={handleFormSaved}
            onCancel={() => {
              setOverlayOpen(false);
              setEditingTeam(null);
            }}
          />
        </div>
      </div>
    )}
  </div>
  );
};

export default TeamsManager;
